import i18n from '@/i18n'
import Point from '@/models/Point'

export default (value) => {
    return i18n.tc('globals.amount_points_short', value instanceof Point ? value.amount : (value || 0))
}